import { fetchIncomingOrdersByDate, fetchTodaysIncomingOrders, fetchTotalPurchases,
  fetchPurchaseOrdersNotReceived, fetchPurchaseOrders, selectPurchaseOrder,
  resetCurrentPurchaseOrder, fetchPurchaseOrderPerformance, fetchPurchaseManagerInfo,
  fetchMonthPerformance, fetchPurchasersPerformance, fetchIncidentReport } from '../../actions/purchaseOrders_actions';
import { fetchInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { fetchFavorites, selectFavorites, resetCurrentFavorites, deleteFavorite } from '../../actions/favorites_actions';
import { fetchVendorRecords } from '../../actions/vendors_actions';
import { fetchNumPurchaseQuotes } from '../../actions/purchaseQuotes_actions';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import PurchaseManagerDashboard from '../../components/Purchase/purchaseManagerDashboard';

let purchaseManagerDashboard = reduxForm({
    form: 'purchaseManagerDashboard',
})(PurchaseManagerDashboard);

const selector = formValueSelector('purchaseManagerDashboard');

function mapStateToProps(state) {
    const dateChosen = selector(state, 'SelectedDate');

    return {
        dateChosen,



        vendorRecords: state.vendors.vendorRecords,
        vendorRecordsIsLoading: state.vendors.vendorRecordsIsLoading,
        vendorRecordsError: state.vendors.vendorRecordsError,

        purchaseOrderPerformance: state.purchaseOrders.purchaseOrderPerformance,
        purchaseOrderPerformanceIsLoading: state.purchaseOrders.purchaseOrderPerformanceIsLoading,
        purchaseOrderPerformanceError: state.purchaseOrders.purchaseOrderPerformanceError,

        purchaseManagerInfo: state.purchaseOrders.purchaseManagerInfo,
        purchaseManagerInfoIsLoading: state.purchaseOrders.purchaseManagerInfoIsLoading,
        purchaseManagerInfoError: state.purchaseOrders.purchaseManagerInfoError,

        lastMonth: state.purchaseOrders.lastMonth,
        lastMonthIsLoading: state.purchaseOrders.lastMonthIsLoading,
        lastMonthError: state.purchaseOrders.lastMonthError,

        purchasersPerformance: state.purchaseOrders.purchasersPerformance,
        purchasersPerformanceIsLoading: state.purchaseOrders.purchasersPerformanceIsLoading,
        purchasersPerformanceError: state.purchaseOrders.purchasersPerformanceError,

        incidentReport: state.purchaseOrders.incidentReport,
        incidentReportIsLoading: state.purchaseOrders.incidentReportIsLoading,
        incidentReportError: state.purchaseOrders.incidentReportError,
    };
}

export default connect(mapStateToProps, {
  fetchVendorRecords, fetchPurchaseOrderPerformance, fetchPurchaseManagerInfo,
  fetchMonthPerformance, fetchPurchasersPerformance, fetchIncidentReport })(purchaseManagerDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseManagerDashboard.jsx